import { render, staticRenderFns } from "./NumberRange.vue?vue&type=template&id=3576d61c&scoped=true"
import script from "./NumberRange.vue?vue&type=script&lang=js"
export * from "./NumberRange.vue?vue&type=script&lang=js"
import style0 from "./NumberRange.vue?vue&type=style&index=0&id=3576d61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576d61c",
  null
  
)

export default component.exports